const React = require('react');
const { Menu: MenuIcon } = require('@material-ui/icons');

const withState = require('../../../../../utils/withState');

const Logo = require('../Logo');
const UserDisplay = require('../UserDisplay');

const HiddenNavigation = require('./HiddenNavigation');

module.exports = withState((setState) => {
  return (state, props) => {
    const isMenuOpen = state.menuOpen
    const toggleMenu = () => setState({menuOpen: !isMenuOpen});
    return (
      <div>
        <HiddenNavigation
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}
        />
        <div className="layoutRow jcSB pr10 fxwWrap">
          <div className="layoutRow aiC">
            <div className="mr10 p20 crPointer" onClick={toggleMenu}>
              <MenuIcon />
            </div>
            <Logo />
          </div>
          <div className="ml20 dN@m2">
            <UserDisplay />
          </div>
        </div>
        <div className="mt10 mb20 ph20">
          {props.children}
        </div>
      </div>
    )
  }
})